import React, { useEffect } from "react";
import "./ColourCurveSelect.css";
import { injectIntl } from "react-intl";

function Option(props) {
  return <option value={props.pk}>{props.label}</option>;
}

function ColourCurveSelect(props) {
  useEffect(() => {
    // If the activeImageId has changed we want to generate the colourized image by refreshing
    if (props.activeImageId && props.colourCurve.selected) {
      props.colourCurve.onChange(props.colourCurve.selected);
    }
  }, [props.activeImageId, props.colourCurve]);

  let options = props.colourCurve.options.list.map(c => {
    return (
      <Option
        key={c.pk}
        pk={c.pk}
        label={c.label}
        selected={props.colourCurve.selected}
      />
    );
  });

  function onChange(e) {
    return props.colourCurve.onChange(Number.parseInt(e.target.value, 10));
  }

  const defaultLabel = props.intl.formatMessage({
    id:
      props.colourCurve.selected === 0
        ? "workspace.colourCurveSelectHint"
        : "workspace.colourCurveSelectNone"
  });

  return (
    <select
      className="not-draggable colour-curve"
      defaultValue={props.colourCurve.selected}
      onChange={onChange}
    >
      <Option
        pk={0}
        label={defaultLabel}
        selected={props.colourCurve.selected}
      />
      {options}
    </select>
  );
}

export default injectIntl(ColourCurveSelect);
